<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="certificaat">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Certificaat </th>
        <td mat-cell *matCellDef="let row"> {{row.certificaat}} </td>
    </ng-container>

	<ng-container matColumnDef="datumKalibratie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum Kalibratie </th>
        <td mat-cell *matCellDef="let row"> {{row.datumKalibratie | date}} </td>
    </ng-container>

	<ng-container matColumnDef="justering">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Justering </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.justering">done</mat-icon> </td>
    </ng-container>

	<ng-container matColumnDef="afkeur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Afkeur </th>
        <td mat-cell *matCellDef="let row"> <mat-icon *ngIf="row.afkeur">done</mat-icon> </td>
    </ng-container>

	<ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td mat-cell *matCellDef="let row"> {{row.status}} </td>
    </ng-container>

</mg-table>
